import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { ConfigError } from './ConfigError';
import { router } from './router';
import { isConfigured } from '@/lib/env';

export function App() {
  if (!isConfigured) return <ConfigError />;

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
